import React, { Component } from 'react';
import _ from 'lodash';
// import { connect } from 'react-redux';
// import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'
import shared from '../../../utils/shared.js';

const LIGHT = "#f7f1e6";
const DARK_BACKGROUND = "#a6946c";
const DARK = "#71532c"
const QuillDeltaToHtmlConverter = require('quill-delta-to-html');

class QuoteTampa extends Component {
  getRenderedContent = () => {
    let renderedContent = null;
    let story = this.props.story;
    let quoteType = _.get(this.props, 'story.contents.custom_fields.story_type.val.value', null);
    let quoteOps = _.get(this.props.story.contents, 'custom_fields.quote.val.ops', _.get(this.props.story.contents, 'custom_fields.quote.default.ops', null));
    let attributionOps = _.get(this.props.story.contents, 'custom_fields.attribution.val.ops', _.get(this.props.story.contents, 'custom_fields.attribution.default.ops', null));
    let quotePrepend = _.get(this.props.story.contents, 'custom_fields.quote.prepend', null);
    let quoteAppend = _.get(this.props.story.contents, 'custom_fields.quote.append', null);

    if (quotePrepend || quoteAppend) {
      quoteOps = shared.appendPrependQuillOps(quoteOps.slice(), quotePrepend, quoteAppend);
    }
    
    let attributionInstance = new QuillDeltaToHtmlConverter(attributionOps, {});
    let quoteOpsInstance = new QuillDeltaToHtmlConverter(quoteOps, {});
    let quoteOpsRichText = quoteOpsInstance.convert();
    let attributionOpsRichText = attributionInstance.convert();

    switch(quoteType) {
      case 'message_ceo':
        renderedContent = this.getMessageFromCeo(quoteOpsRichText, attributionOpsRichText, story);
      break;
      case "quote_type_a":
        renderedContent = this.getRenderedQuoteTypeA(quoteOpsRichText, attributionOpsRichText, story);
      break;
      case "quote_type_b":
        renderedContent = this.getRenderedQuoteTypeB(quoteOpsRichText, attributionOpsRichText, story);
      break;
      case "quote_type_c":
        renderedContent = this.getRenderedQuoteTypeC(quoteOpsRichText, attributionOpsRichText, story);
      break;
      case "quote_type_d":
        renderedContent = this.getRenderedQuoteTypeD(quoteOpsRichText, attributionOpsRichText, story);
      break;
      default:
      break;
    }

    return renderedContent;
  }

  getMessageFromCeo = () => {
    let screenWidth = this.props.screen.screenWidth;
    let pictureObj = _.get(this.props.story.contents, 'images[0]', null);
    let middlePictureObj = _.get(this.props.story.contents, 'images[1]', null);
    let bottomPictureObj = _.get(this.props.story.contents, 'images[2]', null);
    let salutationName = _.get(this.props.story.contents, 'custom_fields.salutation_name.val', null);
    let salutationTitle = _.get(this.props.story.contents, 'custom_fields.salutation_title.val', null);
    let pictureBackground = this.getBackground(pictureObj);
    let middlePictureBackground = this.getBackground(middlePictureObj);
    let bottomPictureBackground = this.getBackground(bottomPictureObj);

    // QuillJS Text
    let bodySectionAOps = _.get(this.props.story.contents, 'custom_fields.body_left.val.ops', _.get(this.props.story.contents, 'custom_fields.body_left.default.ops', null))
    // let bodySectionBOps = _.get(this.props.story.contents, 'custom_fields.body_right.val.ops', _.get(this.props.story.contents, 'custom_fields.body_right.default.ops', null));
    // let greetingsOps = _.get(this.props.story.contents, 'custom_fields.greeting.val.ops', _.get(this.props.story.contents, 'custom_fields.greeting.default.ops', null));
    let bodySectionARichText = new QuillDeltaToHtmlConverter(bodySectionAOps, {}).convert();
    // let bodySectionBRichText = new QuillDeltaToHtmlConverter(bodySectionBOps, {}).convert();
    // let greetingRichText = new QuillDeltaToHtmlConverter(greetingsOps, {}).convert();
    let greeting = _.get(this.props.story.contents, 'custom_fields.greeting.val', null);
    let greetingColor = _.get(this.props.story.contents, 'custom_fields.greeting_color.val', "#FFFFFF");
    let bodyColor = _.get(this.props.story.contents, 'custom_fields.body_color.val', "#FFFFFF");

    let heights = {
      pictureSection: screenWidth * .54907407407407407407,
      emptySpace: screenWidth * .21018518518518518519,
      bodySection: screenWidth * .78754578754578754579,
      bodySectionB: screenWidth * .57407407407407407407,
      innerBodySection: screenWidth * 0.53663003663003663004,
      leftInnerBodySection: screenWidth * .54945054945054945055,
      emptySpaceBottom: screenWidth * .23333333333333333333,
      signature: screenWidth * .13425925925925925926
    }
    let widths = {
      pictureSection: screenWidth * .49074074074074074074,
      nameTitleSection: screenWidth * .50925925925925925926,
      bodySection: screenWidth * .41666666666666666667,
      innerBodySection: screenWidth * .85185185185185185185,
      individualSection: screenWidth * .41666666666666666667
    }
    let tops = {
      name: screenWidth * .22037037037037037037,
      title: screenWidth * .26574074074074074074,
      bodySection: screenWidth * .75925925925925925926,
      bodySectionText: screenWidth * .21111111111111111111,
      bodySectionTextRelative: screenWidth * .08611111111111111111,
      greeting: screenWidth * .03086419753086419753,
      signature: screenWidth * .09589041095890410959,
      middlePictureSection: screenWidth * .54938271604938271605
    }
    let lefts = {
      innerBodySection: screenWidth * .07407407407407407407,
      bodySectionA: screenWidth * .07407407407407407407,
      bodySectionB: screenWidth * .51481481481481481481,
      nameTitle: screenWidth * .04351851851851851852,
      individualBodySeparation: screenWidth * .02407407407407407407,
      signature: screenWidth * .51481481481481481481
    }
    let sizes = {
      name: screenWidth * .03935185185185185185,
      title: screenWidth * .02407407407407407407,
      lineHeight: screenWidth * .02057613168724279835,
      signature: screenWidth * .01876931506849315068,
      signatureName: screenWidth * .02054794520547945205,
      signatureTitle: screenWidth * .01689497716894977169
    }
    let mainPictureSize = `${widths.pictureSection}px ${heights.pictureSection}px`;
    let middlePictureSize = `${this.props.screen.screenWidth}px ${heights.emptySpace}px`;
    let bottomPictureSize = `${this.props.screen.screenWidth}px ${heights.emptySpaceBottom}px`;

    return (
      <div>
        {/* Main Picture */}
        <div style={{ position:"absolute", height: heights.pictureSection, width: widths.pictureSection, backgroundSize: mainPictureSize, backgroundImage: `url(${pictureBackground})` }}/>

        {/* Name and Title */}
        <div style={{ position:"absolute", height: heights.pictureSection, width: widths.nameTitleSection, left: widths.pictureSection, backgroundColor: LIGHT }}>
          <div style={{ color: DARK, top: tops.name, position:"absolute", left: lefts.nameTitle, fontFamily:"serif", fontWeight:"bolder", fontSize: sizes.name }}>
            { this.props.story.name }
          </div>
          <div style={{ color: DARK, top: tops.title, position: "absolute", left: lefts.nameTitle, fontFamily:"serif", fontSize: sizes.title }}>
            { this.props.story.contents.headline }
          </div>
        </div>

        {/* Middle Picture Section */}
        <div style={{ position:"absolute", height: heights.emptySpace, width: "100%", backgroundSize: middlePictureSize, backgroundImage: `url(${middlePictureBackground})`, top: tops.middlePictureSection  }}/>

        {/* Body Section */}
        <div style={{ position:"absolute", height: heights.bodySection, width:"100%", top: tops.bodySection, backgroundColor: LIGHT }}>
          {/* Greeting */}
          <div className="gfont_zapfino p-without-margin ql-size-125px" style={{ position:"relative", top: tops.greeting, width: "100%", color: greetingColor }}>
            {greeting}
          </div>
          {/* Text */}
          <div style={{ position:"relative", top: 0, width: widths.innerBodySection, height: heights.innerBodySection, maxHeight: heights.innerBodySection, left: lefts.innerBodySection, color: bodyColor }}>
            {/* Body */}
            <div className="tampa-ceo-body" style={{ WebkitColumnCount: 2, columnFill:"auto", position:"relative", color: DARK, textAlign:"left", lineHeight: sizes.lineHeight + "px", maxHeight: heights.leftInnerBodySection, overflow:"hidden" }} dangerouslySetInnerHTML={{ __html: bodySectionARichText }} />
            <div style={{ float:"right", width: screenWidth * .41391941391941391941, textAlign:"left", marginTop: .003663003663003663 * this.props.screen.screenWidth }}>
              <strong className="ql-font-crimson-semi-bold ql-size-30px">{salutationName}</strong><br/>
              <span className="ql-font-crimson-regular ql-size-22px">{salutationTitle}</span>
            </div>
            {/* Section B */}
            {/* <div style={{ position:"relative", width: widths.individualSection, height: "100%", float:"left", color: DARK, left: lefts.individualBodySeparation, textAlign:"left", lineHeight: sizes.lineHeight + "px", maxHeight: heights.innerBodySection }} dangerouslySetInnerHTML={{ __html: bodySectionBRichText }} /> */}
            
          </div>
        </div>

        {/* Bottom Empty Space */}
        <div style={{ position:"absolute", width: "100%", height: heights.emptySpaceBottom, backgroundSize: bottomPictureSize, backgroundImage: `url(${bottomPictureBackground})`, bottom: 0 }}/>
      </div> 
    );
  }

  getRenderedQuoteTypeA = (quote, attribution) => {
    let height = this.props.screen.screenHeight / 3;
    let quoteHeight = (height / 3) * 2;
    let attributionHeight = height / 3;
    // let quoteFontColor = _.get(this.props.story, 'contents.custom_fields.quote_color.val', "#FFFFFF");
    // let attributionFontColor = _.get(this.props.story, 'contents.custom_fields.attribution_color.val', "#FFFFFF");

    let topBackgroundObj = _.get(this.props.story, 'contents.images[0]', null);
    let topBackgroundImage = this.getBackground(topBackgroundObj);
    let bottomBackgroundObj = _.get(this.props.story, 'contents.images[1]', null);
    let bottomBackgroundImage = this.getBackground(bottomBackgroundObj);
    let backgroundSize = `${this.props.screen.screenWidth}px ${height}px`;

    return (
      <div>
        <div style={{ position: "absolute", top: 0, width: this.props.screen.screenWidth, height: height, backgroundSize: backgroundSize, backgroundImage: `url(${topBackgroundImage})` }}/>
        <div style={{ position:"absolute", top: height, height: height, backgroundColor: LIGHT, display:"table", width:"100%" }}>
          <div style={{ position:"relative", height: "100%", display:"table-cell", verticalAlign:"middle", marginLeft:"auto", marginRight:"auto" }}>
            <div style={{ position:"relative", height:quoteHeight, width:"100%", display:"flex", alignItems:"center", justifyContent:"center" }}>
              <div className="ql-editor" style={{ position:"relative", textAlign:"center", overflow:"hidden", width: "80%", color: "#71532c" }} dangerouslySetInnerHTML={{ __html: quote }}/>
            </div>
            <div style={{ position:"relative", height: attributionHeight, justifyContent:"center", width:"100%", display:"flex" }}>
              <div className="ql-editor" style={{ position:"relative", textAlign:"center", overflow:"hidden", width: "85%", color: "#71532c" }} dangerouslySetInnerHTML={{ __html: attribution }}/>
            </div>
          </div>
        </div>
        <div style={{ position: "absolute", top: height * 2, width: this.props.screen.screenWidth, height: height, backgroundSize: backgroundSize, backgroundImage: `url(${bottomBackgroundImage})` }}/>
      </div>
    );
  }

  getRenderedQuoteTypeB = (quote, attribution) => {
    let height = this.props.screen.screenHeight / 3;
    let bottomPicObj = _.get(this.props.story, 'contents.images[0]', null);
    let middlePicObj = _.get(this.props.story, 'contents.images[1]', null);
    let quoteHeight = (height / 3) * 2;
    let middlePicture = this.getBackground(middlePicObj);
    let middlePicSize = `${this.props.screen.screenWidth}px ${height}px`;
    let bottomPicture = this.getBackground(bottomPicObj);
    let bottomPicSize = `${this.props.screen.screenWidth}px ${height}px`;
    let attributionHeight = height / 3;
    // let quoteFontColor = _.get(this.props.story, 'contents.custom_fields.quote_color.val', "#FFFFFF");
    // let attributionFontColor = _.get(this.props.story, 'contents.custom_fields.attribution_color.val', "#FFFFFF");
    return (
      <div>
        <div style={{ position:"absolute", top: 0, height: height, backgroundColor: DARK_BACKGROUND, display:"table", width:"100%" }}>
          <div style={{ position:"relative", height: "100%", display:"table-cell", verticalAlign:"middle", marginLeft:"auto", marginRight:"auto" }}>
            <div style={{ position:"relative", height:quoteHeight, width:"100%", display:"flex", alignItems:"center", justifyContent:"center" }}>
              <div className="ql-editor" style={{ position:"relative", textAlign:"center", overflow:"hidden", width: "80%", color: "#FFFFFF" }} dangerouslySetInnerHTML={{ __html: quote }}/>
            </div>
            <div style={{ position:"relative", height: attributionHeight, justifyContent:"center", width:"100%", display:"flex" }}>
              <div className="ql-editor" style={{ position:"relative", textAlign:"center", overflow:"hidden", width: "85%", color: "#FFFFFF" }} dangerouslySetInnerHTML={{ __html: attribution }}/>
            </div>
          </div>
        </div>
        <div style={{ position:"absolute", top: height, width: "100%", height: height, backgroundImage: `url(${middlePicture})` , backgroundSize: middlePicSize }}/>
        <div style={{ position:"absolute", top: height * 2, width: "100%", height: height, backgroundImage: `url(${bottomPicture})` , backgroundSize: bottomPicSize }}/>
      </div>
    );
  }

  getRenderedQuoteTypeC = (quote, attribution) => {
    let height = this.props.screen.screenHeight / 3;
    let middlePicObj = _.get(this.props.story, 'contents.images[0]', null);
    let quoteHeight = (height / 3) * 2;
    let middlePicture = this.getBackground(middlePicObj);
    let middlePicSize = `${this.props.screen.screenWidth}px ${height * 2}px`;
    let attributionHeight = height / 3;
    // let quoteFontColor = _.get(this.props.story, 'contents.custom_fields.quote_color.val', "#FFFFFF");
    // let attributionFontColor = _.get(this.props.story, 'contents.custom_fields.attribution_color.val', "#FFFFFF");
    return (
      <div>
        <div style={{ position:"absolute", top: 0, width: "100%", height: height * 2, backgroundImage: `url(${middlePicture})` , backgroundSize: middlePicSize }}/>
        <div style={{ position:"absolute", top: height * 2, height: height, backgroundColor: LIGHT, display:"table", width:"100%" }}>
          <div style={{ position:"relative", height: "100%", display:"table-cell", verticalAlign:"middle", marginLeft:"auto", marginRight:"auto" }}>
            <div style={{ position:"relative", height:quoteHeight, width:"100%", display:"flex", alignItems:"center", justifyContent:"center" }}>
              <div className="ql-editor" style={{ position:"relative", textAlign:"center", overflow:"hidden", width: "80%", color: "#71532c" }} dangerouslySetInnerHTML={{ __html: quote }}/>
            </div>
            <div style={{ position:"relative", height: attributionHeight, justifyContent:"center", width:"100%", display:"flex" }}>
              <div className="ql-editor" style={{ position:"relative", textAlign:"center", overflow:"hidden", width: "85%", color: "#71532c" }} dangerouslySetInnerHTML={{ __html: attribution }}/>
            </div>
          </div>
        </div>
      </div>
    );
  }
  
  getRenderedQuoteTypeD = (quote, attribution) => {
    let height = this.props.screen.screenHeight / 3;
    let middlePicObj = _.get(this.props.story, 'contents.images[0]', null);
    let quoteHeight = (height / 3) * 2;
    let middlePicture = this.getBackground(middlePicObj);
    let middlePicSize = `${this.props.screen.screenWidth}px ${height * 2}px`;
    let attributionHeight = height / 3;
    return (
      <div>
        <div style={{ position:"absolute", top: height, width: "100%", height: height * 2, backgroundImage: `url(${middlePicture})` , backgroundSize: middlePicSize }}/>

        <div style={{ position:"absolute", top: 0, height: height, backgroundColor: DARK_BACKGROUND, display:"table", width: "100%" }}>
          <div style={{ position:"relative", height: "100%", display:"table-cell", verticalAlign:"middle", marginLeft:"auto", marginRight:"auto" }}>
            <div style={{ position:"relative", height:quoteHeight, width:"100%", display:"flex", alignItems:"center", justifyContent:"center" }}>
              <div className="ql-editor" style={{ position:"relative", textAlign:"center", overflow:"hidden", width: "80%", color: "#FFFFFF" }} dangerouslySetInnerHTML={{ __html: quote }}/>
            </div>
            <div style={{ position:"relative", height: attributionHeight, justifyContent:"center", width:"100%", display:"flex" }}>
              <div className="ql-editor" style={{ position:"relative", textAlign:"center", overflow:"hidden", width: "85%", color: "#FFFFFF" }} dangerouslySetInnerHTML={{ __html: attribution }}/>
            </div>
          </div>
        </div>
      </div>
    );
  }

  getBackground = (displayImage) => {
    if (displayImage) {
      return shared.dp(this.props.screen, displayImage, null);
    }
    return null;
  }
  
  render() {
    try {
      let content = this.getRenderedContent();
      // let backgroundObj = _.get(this.props.story, 'contents.images[0]', null);
      // let background = this.getBackground(backgroundObj);
      // let backgroundSize = `${this.props.screen.screenWidth}px ${this.props.screen.screenHeight}px`;
      
      let style = {
        display:"table",
        height: this.props.screen.r9_16.height,
        textAlign: 'center',
        width: '100%',
        // backgroundSize: backgroundSize, 
        // backgroundImage: "url(" + background + ")"
      }
  
      return (
        <div style={style}>
        {content}
        </div>
      )
    } catch(e) {
      console.log(e)
      return (<span/>)
    }
  }
}

export default QuoteTampa;


// WEBPACK FOOTER //
// ./src/Components/Theme/Tampa/QuoteTampa.jsx